module.exports = __webpack_public_path__ + "img/img_card_error_04@3x.95a114bb.png";